/**=========================================================
 * Module: users.js
 * Users Controller
 =========================================================*/

App.controller('UsersController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.type = 'account';
    $scope.filter = $state.params.filter;
    
    $scope.data = [];
    
    
    
    $scope.table = {
        title: '',
        fields: [
            {
            	available: true,
                hasLink: true,
                name: 'name'
            },{
            	available: true,
                name: 'email'
            }
        ],
        link: {
            action: 'view',
            type: 'user',
            filter: 'id'
        },
        links:[{
            link: !$rootScope.user.admin && !$rootScope.user.groupType=='ADM' ? null : {
                action: 'create',
                type:'user',
                filter: ''
            },
            label: 'labels.ADDNEWUSER'
        }]
    }
      
    if($state.params.action!='email'){
        $scope.page = {
            title: 'labels.USERS',
            subTitle: ''
        };
        D.query($scope.type, $scope.filter, { cache: false }).then(
                function(response){
                    $scope.data = response;
                }
                
            ).catch(function(error){
                    $scope.error = error;
                });
    } else {
        $scope.page = {
            title: 'labels.RECEIVEEMAILS',
            subTitle: ''
        };
        D.query($scope.type, '_related='+$scope.filter, { cache: false }).then(
            function(response){
                $scope.data = [];
                for(var i=0; i<response.length; i++){
                    if($rootScope.user.id!=response[i].id){
                        $scope.data.push(response[i]);
                    }
                }
            }
            
        ).catch(function(error){
                $scope.error = error;
            });

        $scope.setListen = function(user){
            user.action = 'ListenUserEmail';
            user.method = user.listened ? 'add' : 'remove';
            user.listenedStatus = 'status-pending'
            D.save('account', user).then(function(response){
                if(response.id){
                    user.listenedStatus = 'status-saved';
                }
            }).catch(function(err){
                user.listenedStatus = 'status-error';
            });
        }
    }
      
      
  }
  ]);